import { atom } from "jotai";

import {
    type AssistantChatMessageModel,
    type AssistantLensDetails,
    type AssistantLensLifetimeStats,
    type AssistantLensSnapshot,
} from "../model";

export const assistantChatMessagesAtom = atom<AssistantChatMessageModel[]>([]);

export const assistantChatOpenAtom = atom<boolean>(false);

// The Lens whose details page is currently active; at most one at a time.
export const activeAssistantLensDetailsAtom = atom<AssistantLensDetails | null>(null);

// Lifetime stats keyed by Lens key, so details and stats can be published or
// cleaned up in either order; the snapshot only pairs them when the keys match.
export const assistantLensStatsByKeyAtom = atom<Record<string, AssistantLensLifetimeStats>>({});

export const activeAssistantLensSnapshotAtom = atom<AssistantLensSnapshot | null>((get) => {
    const details = get(activeAssistantLensDetailsAtom);
    if (!details) return null;
    const lifetimeStats = get(assistantLensStatsByKeyAtom)[details.lensKey];
    return {
        ...details,
        ...(lifetimeStats ? { lifetimeStats } : {}),
    };
});
